import React from 'react';
import PropTypes from 'prop-types';

import { Hero } from '@lanl-web/lanl-components';
import LandingPageImage from '../../assets/images/featured-image.jpeg';

import './WMHero.scss';
import classNames from 'classnames';

export const WMHero = (props) => {
  const { className } = props;

  const classes = classNames('wm-hero', className);

  return (
    <Hero className={classes} img={LandingPageImage}>
      <div className='hero-text'>
        <h1 className='hero-title'>Weather Machine</h1>
      </div>
    </Hero>
  );
};

WMHero.propTypes = {
  className: PropTypes.string,
};

export default WMHero;
